<template>
  <div class="popup-block fadeIn active" id="popup-id" @click="$emit('close')">
    <div class="popup-block__overlay">
      <div :class="['popup', 'popupClass', `size-${size}`]" @click.stop="">
        <div class="popup__header">
          <div class="popup__header-inner">
            <div class="popup__header-group">
              <div class="popup__header-title" :class="titleClass">
                {{ title }}
              </div>
            </div>
            <div class="popup__header-controls">
              <button class="popup__close-btn" @click.stop="$emit('close')">
                <icon name="close-modal" />
              </button>
            </div>
          </div>
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Components/UI/Icon';

export default {
  components: { Icon },
  props: {
    title: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'md',
      validator(value) {
        return ['sm', 'md', 'lg', 'xl'].includes(value);
      }
    },
    popupClass: {
      default: ''
    },
    titleClass: {
      default: ''
    }
  },
  mounted() {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.$emit('close');
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.students-color-modal .popup {
  max-width: 260px;
}

.modal-small {
  .popup__header-title {
    font-size: 12px;
    line-height: 16px;
  }

  .popup__header-inner {
    padding: 6px;
  }
}

.text-lrt {
  direction: ltr;
}
.popup-settings {
  max-width: 400px;
  &-inner {
    padding: 16px;
  }
  &-title {
    padding: 16px 0;
  }
}
</style>
